// What the main-data QA checks found in the main info (DEV-3119). Those issues belong to the
// submission, not to any entry, so they are listed here rather than in the Delivery grid. A blocking
// one stops the delivery until the main info is fixed.
export default function MainInfoQaIssues({errors, blocked}) {
	if (!errors || errors.length === 0) {
		return null;
	}

	return (
		<div className={`alert ${blocked ? "alert-danger" : "alert-warning"}`} role="alert">
			<b>{blocked ? "Please fix your main info before delivering:" : "Please check your main info:"}</b>
			<ul className="mb-0">
				{errors.map((error, index) => <li key={index}>{error}</li>)}
			</ul>
		</div>
	);
}
